module.exports = __webpack_public_path__ + "static/media/sales3.1b02fd93.webp";